import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  dialogContent: {
    padding: [0, '!important'],
    width: '50%'
  },
  dialogPaper: {
    flexDirection: 'row',
    maxWidth: 1140
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    zIndex: 1
  },
  bigImage: {
    verticalAlign: 'bottom',
    width: '100%'
  },
  content: {
    padding: [theme.spacing(4.625), '!important']
  },
  itemType: {
    marginBottom: theme.spacing(2)
  },
  itemIDTypography: {
    marginBottom: theme.spacing(6),
    color: '#707070'
  },
  divider: {
    margin: theme.spacing(4, 0)
  },
  retailValue: {
    marginBottom: theme.spacing(4)
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/dialogs/Item/styles.js